export default {
  title: 'Primește noutăți și oferte prin e-mail',
  form: {
    marketing_subscription: {
      label: 'Primește oferte exclusive, reduceri și noutăți direct în inbox',
    },
  },
};
